export const LOCALSDKKEY = 'yunli-rtc-sdk';
export const LOCALINFOKEY = 'yunli-rtc-info';
